import React from 'react'

/**
 * Page-level horizontal frame. Two width preferences:
 *   - "prose"  → narrower, used for reading-oriented profile pages.
 *   - "wide"   → full app width, used for tables/listings.
 */
interface ContainerProps {
  width?: 'prose' | 'wide'
  className?: string
  children: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({
  width = 'wide',
  className = '',
  children,
}) => {
  const max = width === 'prose' ? 'max-w-prose' : 'max-w-[1320px]'
  return (
    <div className={`${max} mx-auto px-[max(16px,2.5vw)] ${className}`}>
      {children}
    </div>
  )
}

export default Container
